import * as PIXI from "pixi.js";

export const preenchidoTheme = {
  dragEvents: {
    start: "pointerdown",
    move: "pointermove",
    end: "pointerup",
    endOutside: "pointerupoutside",
  },

  buildVisuals({
    m,
    node,
    textures,
    colorMode,
    editable,
    editMode,
    theme,
    showLabel,
    labelTexture,
  }) {
    const {
      texture,
      markerTextureLight,
      markerTextureDark,
      markerCircleBorder,
      markerDisaster,
    } = textures;

    const isDisaster = m.severity == 5 && !editable;

    const circleTexture = isDisaster
      ? markerDisaster
      : colorMode === "light"
        ? markerTextureLight
        : markerTextureDark;

    const circle = new PIXI.Sprite(circleTexture);
    const circleBase = new PIXI.Sprite(
      isDisaster ? markerDisaster : markerTextureLight,
    );
    circle.tint = isDisaster
      ? PIXI.utils.string2hex(theme.palette.color?.zabbixSeverty?.disaster)
      : 0xffffff;

    circleBase.tint = editMode
      ? PIXI.utils.string2hex(theme.palette.color?.zabbixSeverty?.selected)
      : m.tint
        ? PIXI.utils.string2hex(m.tint)
        : 0xffffff;
    circle.anchor.set(0.5);
    circleBase.anchor.set(0.5);

    /* -- sprite ícone -- */
    const sprite = new PIXI.Sprite(texture);

    // Lida com mudança da cor do icone no modo claro e escuro
    // Altera apenas SVG, para não alterar icones PNG com cores adicionados pelo usuário
    if (texture.baseTexture?.resource?.src?.includes("svg"))
      sprite.tint = "#e6e6e6";
    sprite.anchor.set(0.5, isDisaster ? 0.4 : 0.5);
    sprite.width = isDisaster ? 35 : 40;
    sprite.height = isDisaster ? 35 : 40;

    sprite.baseScale = sprite.scale.clone();

    const border = new PIXI.Sprite(markerCircleBorder);
    border.tint = editMode
      ? PIXI.utils.string2hex(theme.palette.color?.zabbixSeverty?.selected)
      : PIXI.utils.string2hex(m.tint);
    border.anchor.set(0.5);

    node.zIndex = 100;
    if (!isDisaster) node.addChild(border);
    node.addChild(circle);
    node.addChild(circleBase);
    node.addChild(sprite);

    if (showLabel) {
      const titleSprite = new PIXI.Sprite(labelTexture);
      titleSprite.anchor.set(0.5);
      titleSprite.y = -55;
      node.addChild(titleSprite);
    }

    return {
      spriteRefs: { circle, circleBase, border, sprite },
      state: { isDisaster },
    };
  },

  buildExplosion({ m, editable, configElementDataMap, textures }, state) {
    const configEl = configElementDataMap?.get(m.id);
    if (!(configEl?.severity > 1 && !editable)) return null;

    const { markerDisaster, markerTextureLight } = textures;
    const explosion = new PIXI.Sprite(
      state?.isDisaster ? markerDisaster : markerTextureLight,
    );
    explosion.tint = PIXI.utils.string2hex(m.tint);
    explosion.anchor.set(0.5);
    return explosion;
  },
};
